import React, { useState } from 'react';
import { TemplateLibraryButton } from '../TemplateLibraryButton/TemplateLibraryButton.component';
import TemplateLibraryModal from '../TemplateLibraryModal/TemplateLibraryModal.component';
import { TemplateLibraryContextProvider, TemplateLibraryProps } from './TemplateLibrary.context';

export interface TemplateLibraryItem {
  check: boolean;
  templateId: string;
  templateName: string;
  backgroundImage?: string;
};

const TemplateLibrary = (libraryProps: TemplateLibraryProps) => {

  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <TemplateLibraryContextProvider {...{libraryProps, handleClose}} >
      <React.Fragment>
        <TemplateLibraryButton handleOpen={handleOpen} />
        <TemplateLibraryModal
          {...{
            open
          }}
          handleClose={handleClose}
        />
      </React.Fragment>
    </TemplateLibraryContextProvider>
  );
}

export default TemplateLibrary;
